import { Routes, mapToCanActivate } from '@angular/router';
import { CustomerLocationGuard } from '@next/core-lib/relationships';

import { CustomerProductInventoryPrintComponent } from '../overview/components/customer-product-inventory-print/customer-product-inventory-print.component';
import { ReportComponent } from '../overview/components/report/report.component';
import { OverviewV2Component } from './overview-v2.component';

export const overviewV2Routes: Routes = [
  {
    path: '',
    canActivate: mapToCanActivate([CustomerLocationGuard]),
    component: OverviewV2Component,
  },
  { path: 'report', redirectTo: '', pathMatch: 'full' },
  {
    path: 'report/:orderedId',
    component: ReportComponent,
    canActivate: mapToCanActivate([CustomerLocationGuard]),
  },
  {
    path: 'complete-report',
    component: ReportComponent,
    canActivate: mapToCanActivate([CustomerLocationGuard]),
  },
  {
    path: 'inventory',
    component: CustomerProductInventoryPrintComponent,
    canActivate: mapToCanActivate([CustomerLocationGuard]),
  },
];
